import { PageSectionsContentSectionContentBlocksShipping } from '@/tina/__generated__/types';
import * as stylex from '@stylexjs/stylex';
import Image from 'next/image';
import { tinaField } from 'tinacms/dist/react';
import { a11y } from '../styles/a11y';
import { layout } from '../styles/layout';
import '../styles/tokens.stylex';
import { borderRadius, spacing } from '../styles/tokens.stylex';
import { typography } from '../styles/typography';
import { RichText } from './RichText';
interface ShippingInformationProps {
  data: PageSectionsContentSectionContentBlocksShipping;
}
export function ShippingInformation({
  data
}: ShippingInformationProps) {
  return <div {...stylex.props(layout.contentCard, sx.card)}>
      <h2 {...stylex.props(typography.heading2, sx.heading)} data-tina-field={tinaField(data, 'heading')}>
        {data.heading}
      </h2>
      <RichText wrapperStyles={sx.richTextWrapper} data-tina-field={tinaField(data, 'content')}>
        {data.content}
      </RichText>
      <h3 {...stylex.props(a11y.visuallyHidden)}>Shipping Providers:</h3>
      <div className="x78zum5 x1a02dak x16pmaob">
        {data.providers?.map(provider => {
        return provider?.image && provider.providerIsActive && <Image key={provider.providerName?.replace(/\s/, '-').toLowerCase()} className="xakuvmb" alt={provider?.alt} src={provider.image} width={140} height={140} data-tina-field={tinaField(provider, 'image')} />;
      })}
      </div>
    </div>;
}
const sx = {
  card: {
    kmVPX3: "xe8vj48",
    k1xSpc: "xrvj5dj",
    kOIVth: "x16pmaob",
    $$css: true
  },
  heading: {
    kN2L0X: "x1w2vvpw",
    ks0D6T: "x6amaq2",
    $$css: true
  },
  richTextWrapper: {
    ks0D6T: "xe10afn",
    $$css: true
  }
};